function TextInfo({ hasTitle = true, isContentText = true, content, title = '' }) {
  const baseClasses =
    'p-4 bg-white dark:bg-background-dark text-darkgray dark:text-text-dark text-sm rounded-r-2xl rounded-bl-2xl border border-gray';
  const colorClass = hasTitle ? '' : 'rounded-tl-2xl ';

  return (
    <div>
      <div
        className={
          hasTitle
            ? 'w-max p-2 bg-lightblue text-blue font-semibold rounded-t-2xl rounded-r-2xl border-t border-r border-l border-gray'
            : 'hidden'
        }
      >
        <p>{title}</p>
      </div>
      <div className={`${baseClasses} ${colorClass}`}>{isContentText ? <p>{content}</p> : content}</div>
    </div>
  );
}

export default TextInfo;
